import Column from '@amzn/meridian/column';
import { createJasComponent } from 'features/mfe/components/JasComponent';
import type { QASheet } from 'types/JourneysAssetSystemComponents';
import { JagListFilterBar } from '../JagListFilterBar';
import { JagListViewActionBar } from '../JagListViewActionBar/JagListViewActionBar';
import { useJagListViewContext } from '../JagListViewContext';
import { JagListViewTable } from '../JagListViewTable/JagListViewTable';

const ReviewSheet = createJasComponent<typeof QASheet>('QASheet');

export const JagListView = () => {
  const {
    hasQaComment,
    isJourneysAssetSystemQAEnabled,
    localeFilter,
    onCloseReviewSheet,
    openReviewSheet,
    qaStatusFilter,
    selectionState,
  } = useJagListViewContext();

  const selectedJagIds = Object.entries(selectionState)
    .filter(([_, v]) => v)
    .map(([k, _]) => k);

  const queryFilters = {
    jagFilters: {
      ids: selectedJagIds,
    },
    liaFilters: {
      hasQaComment,
      locales: localeFilter,
      qaStatuses: qaStatusFilter,
    },
  };
  return (
    <>
      <Column data-cy="jag-list-view" spacingInset="none">
        <JagListViewActionBar />
        {isJourneysAssetSystemQAEnabled && <JagListFilterBar />}
        <JagListViewTable />
      </Column>
      <ReviewSheet data-cy="jag-list-filter-review-sheet" onClose={onCloseReviewSheet} open={openReviewSheet} queryFilters={queryFilters} />
    </>
  );
};
